import * as measurementUtils from '@/common/helpers/measurements-utilities';

import { getAvailableUnitMetrics } from '@/features/unit-tests-view/services/UnitAnalytics';
import { prefStorage } from '@samknows/utils';
import viewTypes from '@/common/helpers/view-types';

export const namespaced = true;

export const state = {
  formData: [],
  metadata: {},
  showZeroAxis: prefStorage.get('show-zero-axis'),
  showZeroWhite: prefStorage.get('show-zero-white'),
  hideInsignificant: prefStorage.get('hide-insignificant', true),
  chartTypesAvailable: [],
  helpId: undefined,
  tooltipsDisabled: false,
  chartStatus: 'initial',
  isFormDataChangedAfterChartCreation: false,
  data: [],
  failedMetricData: [],
  consolidatedData: [],
  metricsRequestedCount: 0
};

/* eslint-disable no-shadow */
export const mutations = {
  setMetricsRequestedCount(state, n) {
    state.metricsRequestedCount = n;
  },
  setData(state, data) {
    state.data = data;
  },
  setSuccessfulMetric(state, datum) {
    const newData = [...state.data, datum];
    const sortedNewData = newData.sort((a, b) => a.order - b.order);

    state.data = sortedNewData;
    state.consolidatedData = measurementUtils.consolidateResponses(
      state.data,
      state.formData
    );
  },
  setFailedMetric(state, failedMetric) {
    state.failedMetricData = [...state.failedMetricData, failedMetric];
  },
  setChartStatus(state, pageStatus) {
    if (pageStatus === 'initial') {
      state.chartStatus = 'initial';
    }
    if (
      pageStatus === 'loading' ||
      pageStatus === 'loading-slow' ||
      pageStatus === 'reloading'
    ) {
      state.chartStatus = 'loading';
    }
    if (
      !(
        pageStatus === 'initial' ||
        pageStatus === 'loading' ||
        pageStatus === 'loading-slow'
      )
    ) {
      state.chartStatus = 'loaded';
      state.isFormDataChangedAfterChartCreation = false;
    }
  },
  setFormDataChangeStatus(state) {
    state.isFormDataChangedAfterChartCreation = true;
  },
  setFormData(state, formDataArray) {
    if (!Array.isArray(formDataArray)) {
      formDataArray = [formDataArray];
    }

    state.formData = formDataArray.map((formData) =>
      Object.assign({}, formData)
    );
  },
  setMetadata(state, metadata) {
    state.metadata = metadata;
  },
  setShowZeroAxis(state, showZeroAxis) {
    state.showZeroAxis = showZeroAxis;

    prefStorage.set('show-zero-axis', showZeroAxis, true);
  },
  setHideInsignificant(state, hideInsignificant) {
    state.hideInsignificant = hideInsignificant;

    prefStorage.set('hide-insignificant', hideInsignificant, true);
  },
  setShowZeroWhite(state, showZeroWhite) {
    state.showZeroWhite = showZeroWhite;

    prefStorage.set('show-zero-white', showZeroWhite, true);
  },
  setChartTypes(state, chartTypes) {
    state.chartTypesAvailable = chartTypes;
  },
  setHelpId(state, helpId) {
    state.helpId = helpId;
  },
  setTooltipsDisabled(state, tooltipsDisabled) {
    state.tooltipsDisabled = tooltipsDisabled;
  },
  resetData(state) {
    state.data = [];
    state.consolidatedData = [];
    state.failedMetricData = [];
    state.metricsRequestedCount = 0;
  }
};

export const actions = {
  getUnitMetadata({ commit }, unitId) {
    return getAvailableUnitMetrics(unitId).then(({ data }) => {
      // @todo: get this from the backend
      data.metrics.forEach((metric) => {
        if (typeof metric.can_split === 'undefined') {
          metric.can_split = metric.canSplit || true;
        }
      });
      commit('setMetadata', data);
    });
  },
  updateMetadata({ dispatch }) {
    return dispatch('getUnitMetadata', viewTypes.activeView.data.unitId);
  }
};

export const getters = {
  allRequestsHaveReturned(state, getters) {
    return (
      getters.failedMetricsCount + getters.successfulMetricsCount ===
      state.metricsRequestedCount
    );
  },
  failedMetricsCount(state) {
    return state.failedMetricData.length;
  },
  successfulMetricsCount(state) {
    return state.data.length;
  }
};
